/**
 * Google Analytics 4 — lightweight wrapper.
 * Silent no-op unless REACT_APP_GA4_ID is set to a real `G-...` id (not `G-PLACEHOLDER`).
 */

const GA_ID = process.env.REACT_APP_GA4_ID;

function _enabled() {
  return Boolean(GA_ID) && GA_ID !== "G-PLACEHOLDER" && typeof window !== "undefined";
}

let _initialized = false;

export function initGA4() {
  if (!_enabled() || _initialized) return;
  _initialized = true;

  // Inject gtag.js script tag
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // send_page_view: false — we fire page_view manually from the router hook
  // so single-page-app navigations are tracked correctly.
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
}

export function pageView(path, title) {
  if (_enabled() && window.gtag) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: title || document.title,
      page_location: window.location.href,
    });
  }
  // Meta Pixel PageView — fires on every SPA route change.
  // The base pixel in index.html already fires PageView on initial load;
  // this covers subsequent client-side navigations.
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", "PageView");
  }
}

/**
 * Track a Meta Pixel standard event (Lead, CompleteRegistration, Purchase,
 * ViewContent, etc.). Safe no-op if the pixel hasn't loaded.
 */
export function fbEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", name, params);
  }
}

/**
 * Fire a named event. Common names:
 *   sign_up, login, purchase, begin_checkout, generate_lead,
 *   newsletter_subscribe, chat_message_sent, download_asset, book_consultation
 */
export function track(name, params = {}) {
  if (!_enabled() || !window.gtag) return;
  window.gtag("event", name, params);
}
